/**
 * Placeholder look for sigils and cloaks, shared by TV and phone.
 * Step 6 swaps glyphs for illustrated sigils; the keys stay the same.
 */
export const SIGIL_GLYPHS = {
    fox: "🦊",
    raven: "🐦‍⬛",
    stag: "🦌",
    owl: "🦉",
    wolf: "🐺",
    hare: "🐇",
    boar: "🐗",
    serpent: "🐍",
    falcon: "🦅",
    badger: "🦡",
    moth: "🦋",
    heron: "🪶",
    bear: "🐻",
    lynx: "🐈",
    crow: "🐦",
    toad: "🐸",
};
/** Cloak colours chosen to stay distinct on dark backgrounds and for common colour-blindness. */
export const CLOAK_COLOURS = {
    crimson: "#b3263b",
    emerald: "#1f8a5b",
    midnight: "#2b3a8c",
    gold: "#c9a227",
    plum: "#7a3b8f",
    ash: "#8a8f98",
    forest: "#3f6b2a",
    copper: "#b8652f",
    ivory: "#e8e0cc",
    storm: "#4f7f9f",
    rose: "#d0708a",
    obsidian: "#2a2a2e",
};
export function titleCase(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
/** Player-facing names for each phase. */
export const PHASE_LABELS = {
    lobby: "The lobby",
    "role-reveal": "Roles are revealed",
    gathering: "Welcome drinks",
    breakfast: "Breakfast",
    mission: "The mission",
    shield: "A Shield",
    diaries: "Diary room",
    "round-table": "The Round Table",
    vote: "The vote",
    banishment: "Banishment",
    night: "Night falls",
    endgame: "The Endgame",
    finale: "The finale",
};
/** Mission titles for display until scenes read them from the content pack. */
export function titleFromId(id) {
    return id
        .split("-")
        .map((w, i) => (i === 0 || !["of", "the", "a", "in"].includes(w) ? w.charAt(0).toUpperCase() + w.slice(1) : w))
        .join(" ");
}
/** Seconds left until a server-clock deadline, given a clock offset. */
export function secondsLeft(endsAt, offset, now = Date.now()) {
    if (endsAt === null)
        return null;
    return Math.max(0, Math.ceil((endsAt - (now + offset)) / 1000));
}
/** The pot is gold, not real money (spec: keep it points only). */
export function formatPot(pot) {
    return `${pot.toLocaleString("en-GB")} gold`;
}
/** The Host's choice of how missions are played, as shown in the lobby. */
export const MISSION_MODE_CHOICES = [
    { mode: "mix", label: "A mix", hint: "Missions in the room, with quiz rounds on phones every other day." },
    { mode: "physical", label: "In the room", hint: "Build, hunt and perform with things from around the house." },
    { mode: "phone", label: "On phones", hint: "Every mission is a quiz round on everyone's phone." },
];
/**
 * The game's words, softened in Family mode: nobody is "murdered", they're
 * eliminated. Rules are identical either way.
 */
export function wording(family) {
    return family
        ? {
            murdered: "eliminated",
            Murdered: "Eliminated",
            wasMurdered: "was eliminated",
            didNotSurvive: "was eliminated in the night",
            everyoneSurvived: "Nobody was eliminated",
            chooseVictim: "Who leaves the castle tonight?",
            missing: "Somebody hasn't come down to breakfast.",
        }
        : {
            murdered: "murdered",
            Murdered: "Murdered",
            wasMurdered: "was murdered",
            didNotSurvive: "did not survive the night",
            everyoneSurvived: "Everyone survived",
            chooseVictim: "Who dies tonight?",
            missing: "Somebody hasn't come down to breakfast.",
        };
}
//# sourceMappingURL=look.js.map